import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "TeamsModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {},
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "t_bez",
            type: "text",
            label: "_LBL_MODAL_CREATE_TEAMS_BEZ_",
            required: true,
            maxlength: 200,
            view: "v",
          },
          {
            id: "t_kbez",
            type: "text",
            label: "_LBL_MODAL_CREATE_TEAMS_KBEZ_",
            required: true,
            maxlength: 200,
            view: "v",
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: `teams/`, data }).then(
        response => {
          this.addNotification({ text: "_MSG_TEAMS_MODAL_CREATE_SUCCESS_" });
          this.close();
          this.$goTo("root.teams.details", { id: response.pk });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
